import * as React from "react";
import Routes from "./Routes";

const ITEMS: { route: string; href: string; label: string; icon: string }[] = [
  { route: Routes.BLOCKS, href: "index.html?route=BLOCKS", label: "Blocks", icon: "blocks" },
  { route: Routes.DISTRIBUTION, href: "index.html?route=DISTRIBUTION", label: "Coin Distribution", icon: "coins" },
  { route: Routes.RICHLIST, href: "index.html?route=RICHLIST", label: "Top Addresses", icon: "at" },
  { route: Routes.MOVEMENTS, href: "index.html?route=MOVEMENTS", label: "Coin Movements", icon: "swap" },
  { route: Routes.BURNS, href: "index.html?route=BURNS", label: "Burned Coins", icon: "flame" },
  { route: Routes.ASSETS, href: "index.html?route=ASSETS", label: "Assets", icon: "box" },
  { route: Routes.MINING, href: "index.html?route=MINING", label: "Mining", icon: "pick" },
  { route: Routes.NETWORK, href: "index.html?route=NETWORK", label: "Network", icon: "net" },
  { route: Routes.MARKETS, href: "index.html?route=MARKETS", label: "Markets", icon: "chart" },
  { route: Routes.STATS, href: "index.html?route=STATS", label: "Chain Statistics", icon: "bars" },
];

function Icon({ name }: { name: string }) {
  const common = {
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
  switch (name) {
    case "blocks":
      return (
        <svg {...common}>
          <path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3z" />
          <path d="M4 7.5 12 12l8-4.5M12 12v9" />
        </svg>
      );
    case "coins":
      return (
        <svg {...common}>
          <ellipse cx="12" cy="6" rx="7" ry="3" />
          <path d="M5 6v4c0 1.7 3.1 3 7 3s7-1.3 7-3V6" />
          <path d="M5 10v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4" />
        </svg>
      );
    case "at":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="12" r="3" />
          <path d="M15 12v1.8a2 2 0 0 0 3.5 1.2" />
        </svg>
      );
    case "swap":
      return (
        <svg {...common}>
          <path d="M4 9h13M14 5l4 4-4 4" />
          <path d="M20 15H7M10 19l-4-4 4-4" />
        </svg>
      );
    case "flame":
      return (
        <svg {...common}>
          <path d="M12 3c2 4-2 5-1 9 3-1 6-4 6-8 3 3 5 7 5 10a8 8 0 1 1-16 0c0-4 3-8 6-11z" />
        </svg>
      );
    case "box":
      return (
        <svg {...common}>
          <path d="M3 8 12 3l9 5-9 5L3 8z" />
          <path d="M3 8v8l9 5 9-5V8" />
          <path d="M12 13v8" />
        </svg>
      );
    case "pick":
      return (
        <svg {...common}>
          <path d="M14 4h7v3c0 3-3 5-7 5" />
          <path d="M14 12 4 22" />
          <path d="M8 18h4" />
        </svg>
      );
    case "net":
      return (
        <svg {...common}>
          <rect x="9" y="3" width="6" height="6" rx="1" />
          <rect x="3" y="15" width="6" height="6" rx="1" />
          <rect x="15" y="15" width="6" height="6" rx="1" />
          <path d="M12 9v3H6v3M12 12h6v3" />
        </svg>
      );
    case "chart":
      return (
        <svg {...common}>
          <path d="M4 18V6M4 18h16" />
          <path d="M7 14l4-4 3 3 5-6" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <path d="M5 19V9M10 19V5M15 19v-7M20 19V8" />
        </svg>
      );
  }
}

export function Sidebar() {
  const route = new URLSearchParams(window.location.search).get("route") || "HOME";
  const active = route === "HOME" ? "BLOCKS" : route;

  return (
    <aside className="side-nav" aria-label="Explorer sections">
      {ITEMS.map((item) => (
        <a
          key={item.route}
          href={item.href}
          className={active === item.route ? "active" : ""}
        >
          <Icon name={item.icon} />
          <span>{item.label}</span>
        </a>
      ))}
    </aside>
  );
}
